import { Coordinate } from './coodinate';
import { z } from 'zod';

export const Rectangle = z.object({
    min: Coordinate.default({ x: 0, y: 0, systemId: 0 }),
    max: Coordinate.default({ x: 1, y: 1, systemId: 0 }),
});
export type Rectangle = z.infer<typeof Rectangle>;
